import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import { getApiURL } from '../../constants';
import { IPartner, IPartners, IColors } from '../../interfaces/Conference';
import { Image, Label, LabelPatron, ImagePatron, PatronBlock, Link, Row, Wrapper, Title, TitleSymbol } from './ConferenceGuarantors.elements';

interface ConferenceProps {
    garantPartners?: Array<IPartners>;
    patronPartners?: Array<IPartners>;
    colors?: IColors;
}

const ConferenceGuarantorsTemplate: FC<ConferenceProps> = ({ garantPartners, patronPartners, colors }) => {
    const { t } = useTranslations();
    return (
        <Wrapper>
            {patronPartners.length > 0 && (
                <>
                    <Title colors={colors}>
                        {t('conference.general.patron')}
                        <TitleSymbol colors={colors} />
                    </Title>
                    <Row>
                        {patronPartners.map((item: IPartner, index: number) => (
                            <PatronBlock key={`headpartner${index}`}>
                                {item.description && (
                                    <LabelPatron>{item.description}</LabelPatron>
                                )
                                }
                                <ImagePatron>
                                    <Link href={item.url} target="_blank" >
                                        <Image
                                            src={`${getApiURL()}/media/thumbnail/partner/${item.photo}?size=200`}
                                            alt={item.photo}
                                            title={item.name}
                                        />
                                    </Link>
                                </ImagePatron>
                            </PatronBlock>
                        ))}
                    </Row>
                </>
            )}

            {garantPartners.length > 0 && (
                <>
                    <Title colors={colors}>
                        {t('conference.general.garants')}
                        <TitleSymbol colors={colors} />
                    </Title>
                    <Row>
                        {garantPartners.map((item: IPartner, index: number) => (
                            <Link href={item.url} target="_blank" key={`headgarant${index}`}>
                                <Image
                                    src={`${getApiURL()}/media/thumbnail/partner/${item.photo}?size=200`}
                                    alt={item.photo}
                                    title={item.name}
                                />
                            </Link>
                        ))}
                    </Row>
                </>
            )}
        </Wrapper>
    );
};

export default ConferenceGuarantorsTemplate;
